import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const ShopCtx = createContext(null);
const load = (k) => JSON.parse(localStorage.getItem(k) || "[]");

export const ShopProvider = ({ children }) => {
  const [cart, setCart] = useState(() => load("kt_cart"));
  const [wishlist, setWishlist] = useState(() => load("kt_wish"));
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => localStorage.setItem("kt_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => localStorage.setItem("kt_wish", JSON.stringify(wishlist)), [wishlist]);

  const addToCart = (p, size, color, qty = 1, open = true) => {
    const key = `${p.slug}-${size}-${color}`;
    setCart((c) => {
      const ex = c.find((i) => i.key === key);
      if (ex) return c.map((i) => (i.key === key ? { ...i, qty: Math.min(i.qty + qty, 10) } : i));
      return [...c, { key, slug: p.slug, name: p.name, image: p.images[0], price: p.price, mrp: p.mrp, size, color, qty }];
    });
    toast.success(`${p.name} added to bag`, { description: `Size ${size} · ${color}` });
    if (open) setCartOpen(true);
  };
  const updateQty = (key, qty) => setCart((c) => (qty < 1 ? c.filter((i) => i.key !== key) : c.map((i) => (i.key === key ? { ...i, qty } : i))));
  const clearCart = () => setCart([]);
  const isWished = (slug) => wishlist.some((w) => w.slug === slug);
  const toggleWish = (p) => {
    if (isWished(p.slug)) {
      setWishlist((w) => w.filter((x) => x.slug !== p.slug));
      toast("Removed from wishlist");
    } else {
      setWishlist((w) => [...w, p]);
      toast.success("Saved to wishlist");
    }
  };
  const count = cart.reduce((s, i) => s + i.qty, 0);
  const subtotal = cart.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <ShopCtx.Provider value={{ cart, addToCart, updateQty, clearCart, count, subtotal, cartOpen, setCartOpen, wishlist, toggleWish, isWished }}>
      {children}
    </ShopCtx.Provider>
  );
};

export const useShop = () => useContext(ShopCtx);
